import { wrapFormComponentWithLabelAndError } from './StyledFormComponentWrappers';
import TreeSelect from 'shared/components/TreeSelect';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

const RawTreeSelect = TreeSelect;

const RawTreeSelectField = wrapFormComponentWithLabelAndError(RawTreeSelect);
RawTreeSelectField.displayName = 'RawTreeSelectField';

const TreeSelectField = connectFormComponentToReduxForm(RawTreeSelectField);
TreeSelectField.displayName = 'TreeSelectField';
export default TreeSelectField;
